// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3e62b06","821":"b8ba82bf"}[chunkId] + ".chunk.js";
};